import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Export24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M4.46939 12C4.46939 7.84096 7.84096 4.46939 12 4.46939C16.159 4.46939 19.5306 7.84096 19.5306 12C19.5306 16.159 16.159 19.5306 12 19.5306C7.84096 19.5306 4.46939 16.159 4.46939 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12 7.4082C12.4057 7.4082 12.7347 7.73714 12.7347 8.1429V14.6345L14.2356 13.1336C14.5225 12.8467 14.9877 12.8467 15.2746 13.1336C15.5615 13.4205 15.5615 13.8857 15.2746 14.1726L12.5195 16.9277C12.376 17.0712 12.188 17.1429 12 17.1429C11.9004 17.1429 11.8054 17.1231 11.7188 17.0871C11.6321 17.0513 11.5509 16.9982 11.4805 16.9277L8.72538 14.1726C8.43846 13.8857 8.43846 13.4205 8.72538 13.1336C9.0123 12.8467 9.47748 12.8467 9.76439 13.1336L11.2653 14.6345V8.1429C11.2653 7.73714 11.5942 7.4082 12 7.4082Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
